import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import {ContentContext} from "../common/ContentContext";
import Button from "../common/Button";
import useCurrentConcept from "../hooks/useCurrentConcept";
import {UserContext} from "../common/UserContext";
import {BrandContext} from "../common/BrandContext";
import {ArrowRightIcon} from "../common/icons";

const MyCourseNextTopicDashboardWidget = props => {
    const {...other} = props;
    const {content} = useContext(ContentContext);
    const {user} = useContext(UserContext);
    const brandConfig = useContext(BrandContext);
    const {loadCurrentConcept} = useCurrentConcept();
    const [isLoading, setLoading] = useState(false);
    const [nextConcept, setNextConcept] = useState();

    const loadNextConcept = () => {
        if(content.currentTopic !== undefined && content.currentTopic.nextTopicId !== undefined) {
            setLoading(true);
            axios.get('/web/ui/content/topic/' + content.currentTopic.nextTopicId + '/firstConcept')
                .then(response => {
                    setNextConcept(response.data);
                    setLoading(false);
                });
        } else if(user.syllabusId !== undefined) {
            setLoading(true);
            axios.get('/web/ui/content/syllabus/' + user.syllabusId + '/firstConcept')
                .then(response => {
                    setNextConcept(response.data);
                    setLoading(false);
                });
        } else {
            setNextConcept(undefined);
            setLoading(false);
        }
    }

    const handleClick = conceptId => {
        loadCurrentConcept(conceptId);
    }

    useEffect(() => {
        loadNextConcept();
    }, []);

    return (
        <DashboardWidget
            title={
                <div className="ch-dashboard-title-with-icon">
                    <svg className="ch-icon-medium" viewBox="0 0 128 128">
                        <use href="#navLessons-icon"></use>
                    </svg>
                    {(content.currentTopic === undefined || content.currentTopic.nextTopicId === undefined) &&
                        <span>First {brandConfig.topicName.toLowerCase()}</span>
                    }
                    {content.currentTopic !== undefined && content.currentTopic.nextTopicId !== undefined &&
                        <span>Next {brandConfig.topicName.toLowerCase()}</span>
                    }
                </div>
            }
            isLoading={isLoading}
            {...other}>
            {nextConcept !== undefined &&
                <div className={'ch-dashboard-blk-body'} style={{'overflowY': 'unset'}}>
                    <p className="text-muted ch-mathjax padding-b--s" dangerouslySetInnerHTML={{__html: nextConcept.topicName}}/>
                    <Button type="outline"
                            style={{justifyContent: 'space-between', width: '100%'}}
                            onClick={() => handleClick(nextConcept.conceptId)}>
                        <span style={{overflow: 'hidden', textOverflow: 'ellipsis'}}>{nextConcept.conceptName}</span>
                        <span><ArrowRightIcon height={20} width={20}/></span>
                    </Button>
                </div>
            }
        </DashboardWidget>
    )
}

export default MyCourseNextTopicDashboardWidget;